import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Messages Redux States
import { GET_CSAT, GET_NPS } from "./actionTypes";
import { headerError, setCsat, setNps } from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* getCsat() {
  try {
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_URL}/csat/user`
    );

    if (response.status === 200) {
      yield put(setCsat({ lastUpdate: new Date(), ...response?.data?.data }));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message = "Get csat error";
    yield put(headerError({ action: "get_csat", message: message }));
  }
}

export function* watchGetCsat() {
  yield takeEvery(GET_CSAT, getCsat);
}

function* getNps() {
  try {
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_URL}/nps/user`
    );

    if (response.status === 200) {
      yield put(setNps({ lastUpdate: new Date(), ...response?.data?.data }));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message = "Get nps error";
    yield put(headerError({ action: "get_nps", message: message }));
  }
}

export function* watchGetNps() {
  yield takeEvery(GET_NPS, getNps);
}


function* authSaga() {
  yield all([fork(watchGetCsat),fork(watchGetNps)]);
}

export default authSaga;
